import { ICellRendererParams } from "ag-grid-community";
import React from "react";

import { IgTypography } from "@intelligems/ig-theme";
import { OrganizationSummarySubscriptionProductDto } from "@intelligems/ig-types";

import { formatDeprecatedAmount } from "../deprecated-subscription-utils";

export const AmountColumn = (
  params: ICellRendererParams<OrganizationSummarySubscriptionProductDto>
) => {
  if (!params.data) {
    return null;
  }

  let price: string;
  if (params.data.price) {
    price = formatDeprecatedAmount(
      params.data.price,
      params.data.interval,
      params.data.intervalCount || 1
    );
  } else {
    price = "Pending";
  }

  return <IgTypography variant={"body2"}>{price}</IgTypography>;
};
